import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './posthog';
// import App from './App';
import ErrorBoundary from 'component/ErrorBoundary';
import Loader from 'component/ui/loader';
import { applyDarkMode, getStoredDarkMode } from './utils/theme';
const App = React.lazy(() => import('./App'));

// Set the theme before the first paint so admin/public never flash light.
applyDarkMode(getStoredDarkMode());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <React.Suspense fallback={<Loader />}  >
      <App />
    </React.Suspense>
  </ErrorBoundary>

);

